import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-162378f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

import { useField } from "vee-validate";
import { useAttrs, ref } from "vue";

interface ListItem {
    [key: string]: any;
    [key: string]: any;
    label?: string;
    value?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AbitCheckList',
  props: {
    name: {},
    label: {},
    options: {},
    updKey: {},
    labelKey: {},
    valueKey: {},
    required: { type: Boolean },
    horizontal: { type: Boolean },
    wrapperClass: {},
    emptyMessage: {},
    columns: {}
  },
  emits: ["change"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const attrs = useAttrs();
const values = ref<any>([]);
const { value, errorMessage } = useField(props.name);

const emits = __emit;

return (_ctx: any,_cache: any) => {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
            props.wrapperClass || 'a',
            props.horizontal && 'horizontal-wrapper',
        ])
  }, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          class: _normalizeClass([
                'form-label',
                props.required && 'required',
                props.horizontal && 'horizontal',
            ])
        }, _toDisplayString(props.label), 3))
      : _createCommentVNode("", true),
    _createVNode(_component_el_checkbox_group, {
      modelValue: _unref(value),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(value) ? (value).value = $event : null)),
      class: _normalizeClass(`vertical${props?.columns ? ' row' : ''}`),
      onChange: _cache[1] || (_cache[1] = ($event: any) => (emits('change', _unref(value))))
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.options, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass(
                    props?.columns ? `col-md-${12 / props.columns}` : 'full'
                )
          }, [
            _createVNode(_component_el_checkbox, _mergeProps(_unref(attrs), {
              value: item[_ctx.valueKey || 'value'],
              size: "large"
            }), {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "default", { row: item }, () => [
                  _createTextVNode(_toDisplayString(item[_ctx.labelKey || "label"]), 1)
                ])
              ]),
              _: 2
            }, 1040, ["value"])
          ], 2))
        }), 128)),
        (!_ctx.options || _ctx.options.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.emptyMessage || "Nessun elemento in lista"), 1))
          : _createCommentVNode("", true),
        (_unref(errorMessage))
          ? (_openBlock(), _createElementBlock("label", _hoisted_2, _toDisplayString(_unref(errorMessage)), 1))
          : _createCommentVNode("", true)
      ]),
      _: 3
    }, 8, ["modelValue", "class"])
  ], 2))
}
}

})